import { Box, Chip, Stack, Switch, Tooltip, Typography, useTheme } from "@mui/material";
import CustomIcon from "components/CustomIcon";
import { useIntl } from "react-intl";
import icons from "enums/icons";

const ScoringPill = ({
    showDefinitions,
    disabled,
    toggleDefinitions,
    isBoardPage,
}: {
    showDefinitions?: boolean;
    disabled?: boolean;
    toggleDefinitions?: () => void;
    isBoardPage?: boolean;
}) => {
    const theme = useTheme();
    const intl = useIntl();

    const ABILITY_SCORES = [
        {
            id: 0,
            label: "Strong score",
            value: "70+",
            color: theme.palette.others.paleGreen,
            icon: icons.thumbUp,
        },
        {
            id: 1,
            label: "Average score",
            value: "40-70",
            color: theme.palette.others.paleYellow,
            icon: icons.thumbRight,
        },
        {
            id: 2,
            label: "Developmental",
            value: "0-40",
            color: theme.palette.others.paleRed,
            icon: icons.thumbDown,
        },
    ];

    return (
        <Box
            sx={(theme) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: theme.palette.background.grey,
                padding: 1,
                flexFlow: "wrap",
            })}
        >
            <Stack direction="row" gap={1}>
                {ABILITY_SCORES.map((score) => (
                    <Chip
                        key={score.id}
                        variant="outlined"
                        sx={{
                            minWidth: 243,
                            height: 27,
                            border: `2px solid ${score.color}`,
                            "& .MuiChip-icon": {
                                ml: "-1px",
                                pl: 0,
                                pr: 0,
                            },
                            "& .MuiChip-label": {
                                padding: "0 16px 0 8px",
                                width: "100%",
                            },
                        }}
                        icon={<CustomIcon icon={score.icon} />}
                        label={
                            <Box display="flex" justifyContent="space-between" alignItems="center" width="100%" mx={1}>
                                <Typography variant="body2" sx={{ fontStyle: "italic" }}>
                                    {score.label}
                                </Typography>
                                <Typography variant="body2" sx={{ fontStyle: "italic" }}>
                                    {score.value}
                                </Typography>
                            </Box>
                        }
                    />
                ))}
            </Stack>

            {!isBoardPage && (
                <Box display="flex" alignItems="center">
                    <Tooltip
                        arrow
                        placement="bottom-end"
                        title={intl.formatMessage({ id: "leadershipOverview.toggle.tooltip" })}
                    >
                        <Typography sx={{ fontSize: 15, letterSpacing: "0.11px", fontWeight: 500 }}>
                            {intl.formatMessage({ id: "LeadershipOverview.toggle.label" })}
                        </Typography>
                    </Tooltip>

                    <Switch
                        disableRipple
                        size="small"
                        checked={showDefinitions}
                        onChange={toggleDefinitions}
                        disabled={disabled}
                        sx={{
                            "& .MuiSwitch-thumb": {
                                backgroundColor: theme.palette.primary.main,
                            },
                            "& .Mui-disabled .MuiSwitch-thumb": {
                                backgroundColor: `${theme.palette.text.disabled} !important`,
                            },
                            "& .Mui-disabled + .MuiSwitch-track": {
                                backgroundColor: `${theme.palette.text.disabled} !important`,
                                opacity: 0.5,
                            },
                        }}
                    />
                </Box>
            )}
        </Box>
    );
};

export default ScoringPill;
